import { FilePreview } from "@/components/FilePreview";
import { Card } from "@/components/Card";
import { Button } from "@/components/Button";
import React from "react";
import { useTheme } from "@/hooks/useTheme";
import { FileDetails } from "@/containers/FileDetails";
import { useFela } from "react-fela";

interface IProps {
  fileName: string;
  downloadUrl: string;
  onRepairAnotherFile: () => void;
}

export const DownloadFile: React.FC<IProps> = props => {
  const { fileName, downloadUrl, onRepairAnotherFile } = props;

  const { css } = useFela();
  const { bp } = useTheme();

  return (
    <FilePreview>
      <Card
        customStyle={{
          marginTop: 25,
          marginBottom: -6,
          boxShadow: "0 2px 22px 0 rgba(0, 0, 0, 0.08)",
          [bp.FROM_TABLET]: {
            padding: "28px 30px 28px 30px",
          },
          nested: {
            "> div:not(:first-of-type)": {
              marginTop: 20,
            },
          },
        }}
      >
        <FileDetails
          name={fileName}
          modifiedDate={Date.now()}
          downloadUrl={downloadUrl}
        />
        <span
          className={css({
            width: 320,
            marginTop: 35,
            margin: "0 auto",
            borderBottom: "1px solid #F5F5F7",
          })}
        />
        <Button onClick={onRepairAnotherFile}>Repair another file!</Button>
      </Card>
    </FilePreview>
  );
};
